import { useState } from 'react';
import { faqs, type Faq } from '@/mocks/faqs';

export default function FaqAccordion({ items }: { items?: Faq[] }) {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const list = items ?? faqs;

  return (
    <div className="flex flex-col gap-3">
      {list.map((item, idx) => {
        const open = openIndex === idx;
        return (
          <div
            key={item.q}
            className={`overflow-hidden rounded-2xl bg-background-100 ring-1 transition-colors ${
              open ? 'ring-primary-300' : 'ring-background-200/70'
            }`}
          >
            <button
              type="button"
              onClick={() => setOpenIndex(open ? -1 : idx)}
              aria-expanded={open}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-semibold text-secondary-700">
                  Q
                </span>
                <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
              </span>
              <i
                className={`ri-add-line text-foreground-500 transition-transform duration-300 ${
                  open ? 'rotate-45 text-primary-500' : ''
                }`}
              />
            </button>
            {open && (
              <div className="px-5 pb-5 pl-[3.75rem]">
                <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}